import React from "react";
import { Helmet } from "react-helmet";
import { useStaticQuery, graphql } from "gatsby";

const SeoComponent = (props) => {
  const defaultMeta = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          title
          description
          siteUrl
        }
      }
    }
  `);

  function appendCoopBlogString(string) {
    return `${string} | Co-op Blog`;
  }

  const defaults = defaultMeta?.site?.siteMetadata;

  const title = props.title
    ? appendCoopBlogString(props.title)
    : defaults.title;

  function stripHtmlTags(string) {
    let myLocalString = string || "";
    return myLocalString.replace(/<[^>]+>/g, "");
  }

  const description = stripHtmlTags(props.description) || defaults.description;

  return (
    <>
      <Helmet htmlAttributes={{ lang: "en" }}>
        <title>{title}</title>
        <meta name="description" content={description}></meta>
      </Helmet>
    </>
  );
};

export default SeoComponent;
